import React, {useEffect, useState} from 'react';
import {useQuery} from '@apollo/react-hooks';
import {GET_HEXOMATIC_USER} from '../../../graphql/queries';
import {closeIcon} from '../../../images/svgIcons';
import PricingCard from '../pricing-card';
import CustomModal from '../../customModal/index';
import EnterpriseForm from '../../enterprise-form';
import Button from '../../button';
import {Modal} from '../../../components/modal';

import pricingIcon from '../../../images/pricing/pricing-hint.png';
import {checkedCircleIcon} from '../../../images/svgIcons/index';
import './styles.scss';

const gold = [
  {
    isBold: true,
    text: 'All the benefits of Silver, plus:',
  },
  {
    isChecked: true,
    text: (
      <>
        Automation credits <br /> (Monthly renewing quota)
      </>
    ),
  },
  {
    select: true,
    text: 'Simultaneous running workflows',
  },

  {
    isChecked: true,
    text: (
      <div>
        Simultaneous running workflows
        <div
          className="p-1"
          style={{
            background: '#825FEC',
            color: 'white',
            width: 'fit-content',
            borderRadius: '3px',
          }}
        >
          Unlimited{' '}
        </div>
      </div>
    ),
  },
  {
    isChecked: true,
    text: 'API',
  },
];

const enterPrise = [
  {
    isBold: true,
    text: 'All the benefits of Gold, plus:',
  },

  {
    isChecked: true,
    text: 'Personalized onboarding',
  },
  {
    isChecked: true,
    text: 'Team training',
  },

  {
    isChecked: true,
    text: 'Campaign setup and management',
  },
  {
    isChecked: true,
    text: 'Dedicated strategy consultant',
  },
];

const hexomaticPackages = (name: string, credits: number, count: number) => {
  const obj = {
    FREE: [
      {
        number: credits,
        text: (
          <>
            Automation credits <br /> (Monthly renewing quota)
          </>
        ),
      },
      {
        number: count,
        text: 'Simultaneous running workflows',
      },
      {
        number: 1,
        text: 'Create your own automation recipe',
      },
      {
        isChecked: true,
        text: 'Export to CSV and Google sheet',
      },
      {
        isChecked: true,
        text: 'Notifications to Telegram, Slack, email',
      },
      {
        isChecked: true,
        text: 'Get access to community automation recipes',
      },
    ],
    BRONZE: [
      {
        isBold: true,
        text: 'All the benefits of Free, plus:',
      },
      {
        number: credits,
        text: (
          <>
            Automation credits <br /> (Monthly renewing quota)
          </>
        ),
      },
      {
        number: count,
        text: 'Simultaneous running workflows',
      },
      {
        number: 1,
        text: 'Create your own automation recipe',
      },
      {
        isChecked: true,
        text: 'Scheduling',
      },
      {
        isChecked: true,
        text: (
          <>
            Access premium automations <br />
            (requires premium credits)
          </>
        ),
      },
      {
        isChecked: true,
        text: (
          <>
            Access residential proxies <br />
            (requires premium credits)
          </>
        ),
      },
    ],
    SILVER: [
      {
        isBold: true,
        text: 'All the benefits of Bronze, plus:',
      },
      {
        number: credits,
        text: (
          <>
            Automation credits <br /> (Monthly renewing quota)
          </>
        ),
      },
      {
        number: count,
        text: 'Simultaneous running workflows',
      },
      {
        isChecked: true,
        text: 'Advanced integrations',
      },
      {
        isChecked: true,
        text: 'Create your own automation recipes',
      },
      {isChecked: true, text: 'Datacentre IP rotation'},
    ],
    GOLD: gold,
  };
  //@ts-ignore
  return obj[name];
};

const PricingPackeges = ({interval, products}: {products: any; interval: 'monthly' | 'ltd' | 'annual'}) => {
  //-----------------------State--------------------------

  const [user, setUser] = useState<any>(null);
  const [verified, setVerified] = useState(false);
  const [currentPackage, setCurrentPackage] = useState('');
  const [showUpgradeContact, setShowUpgradeContact] = useState(true);
  const [packeges, setPackeges] = useState<{
    annual: any[];
    monthly: any[];
    ltd: any[];
  }>({annual: [], monthly: [], ltd: []});
  const [showEnterpriseModal, setShowEnterpriseModal] = useState(false);
  const [showSentMsg, setShowSentMsg] = useState(false);

  //---------------------Queries--------------------------
  const {data: hexomaticUser, loading, refetch} = useQuery(GET_HEXOMATIC_USER, {
    fetchPolicy: 'no-cache',
  });
  //---------------------useEffects------------------------
  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    if (
      hexomaticUser &&
      hexomaticUser.User &&
      hexomaticUser.User.get &&
      hexomaticUser.HexomaticUser &&
      hexomaticUser.HexomaticUser.getByLegacyId
    ) {
      setVerified(hexomaticUser.User.get.verified);
      setUser({
        email: hexomaticUser.User.get.email,
        ...hexomaticUser.HexomaticUser.getByLegacyId,
      });
      setCurrentPackage(hexomaticUser.HexomaticUser.getByLegacyId.pricing_package);
    }
  }, [hexomaticUser]);
  useEffect(() => {
    if (products) {
      const packages_annual: any = {};
      const packages_ltd: any = {};
      const packages: any = {};
      products.map((item: any) => {
        const el = {
          id: item.id,
          interval: item.interval,
          name: item.name,
          price: item.amount,
          lineThrough: item.interval === 'LTD',
          trigger: !!(item.interval === 'LTD' && item.amount),
          flag: item.name === 'GOLD',
          real_price:
            item.interval === 'ANNUAL'
              ? products.find((subItem: any) => subItem.interval === 'MONTHLY' && subItem.name === item.name).amount
              : null,
          disabled: true,
          pricingList: hexomaticPackages(
            item.name,
            item.limits.credits_count,
            item?.actions?.workflow?.simultaneous_running_workflow_count || 0,
          ),
        };
        if (item.name === 'FREE') {
          el.disabled = true;
        } else if (item.name === 'BRONZE') {
          el.disabled =
            (interval !== 'ltd' && user && user.pricing_package_interval === 'LTD') ||
            !currentPackage ||
            (currentPackage &&
              (currentPackage === 'BRONZE' || currentPackage === 'SILVER' || currentPackage === 'GOLD'))
              ? user && user.id
                ? true
                : false
              : false;
        } else if (item.name === 'SILVER') {
          el.disabled =
            (interval !== 'ltd' && user && user.pricing_package_interval === 'LTD') ||
            !currentPackage ||
            (currentPackage && (currentPackage === 'SILVER' || currentPackage === 'GOLD'))
              ? user && user.id
                ? true
                : false
              : false;
        } else el.disabled = interval !== 'ltd' && user && user.pricing_package_interval === 'LTD';
        //@ts-ignore
        if (item.interval === 'ANNUAL') packages_annual[item.name] = el;
        //@ts-ignore
        else if (item.interval === 'LTD') packages_ltd[item.name] = el;
        //@ts-ignore
        else if (item.interval === 'MONTHLY') packages[item.name] = el;
      });
      setPackeges({
        annual: [packages.FREE, packages_annual.BRONZE, packages_annual.SILVER, packages_annual.GOLD],
        ltd: [packages.FREE, packages_ltd.BRONZE, packages_ltd.SILVER, packages_ltd.GOLD],
        monthly: [packages.FREE, packages.BRONZE, packages.SILVER, packages.GOLD],
      });
    }
  }, [products, user]);
  const handleCloseModal = () => setShowUpgradeContact(false);

  return (
    <div className="pricing-packages-wrapper">
      {interval !== 'ltd' && user && user.pricing_package_interval === 'LTD' && showUpgradeContact && (
        <div className="text-center all-disabled">
          <span onClick={handleCloseModal}>{closeIcon}</span>
          <img src={pricingIcon} alt="icon" />
          <div>Need to upgrade your plan? </div>
          <div className="support">
            Please contact{' '}
            <a href="mailto:support@hexomatic.com" className="color-hexomatic" aria-label={'mail'}>
              support@hexomatic.com
            </a>
            {'.'}
          </div>
        </div>
      )}
      <div className="pricing-cards-main-wrapper">
        {packeges[interval].map((item: any) => (
          <div className="inner-wr">
            <PricingCard
              trigger={interval === 'ltd' ? item.price : undefined}
              name={item.name[0] + item.name.slice(1).toLowerCase()}
              price={item.price}
              lineThrough={item.lineThrough}
              flag={item.flag}
              pricingList={item.pricingList}
              disabled={item.disabled || loading || !user}
              user={user}
              packeges={packeges[interval]}
              interval={interval}
              verified={verified}
              id={item.id}
              refetch={refetch}
            />
          </div>
        ))}
        <div className="inner-wr">
          <PricingCard
            trigger={0}
            name={'Enterprise'}
            price={0}
            lineThrough={false}
            flag={undefined}
            handleEnterpriseClick={() => setShowEnterpriseModal(true)}
            pricingList={enterPrise}
            disabled={false}
            user={user}
            isEnterprise
            packeges={packeges[interval]}
            interval={interval}
            verified={verified}
            id={'Enterprise'}
            refetch={refetch}
          />
        </div>
      </div>

      {showEnterpriseModal && (
        <CustomModal setShowPopup={setShowEnterpriseModal} noNavigate>
          <EnterpriseForm setShowEnterpriseModal={setShowEnterpriseModal} setShowSentMsg={setShowSentMsg} />
        </CustomModal>
      )}

      <Modal
        isOpen={showSentMsg}
        modalFooter={
          <Button primary onClick={() => setShowSentMsg(false)}>
            Close
          </Button>
        }
        modalToggle={() => {}}
        title=""
      >
        <div className="d-flex mt-3 flex-column align-items-center justify-content-center">
          <div className="check-icon">{checkedCircleIcon}</div>
          <div className="mt-3">
            <strong>The message has been successfully sent.</strong>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PricingPackeges;
